import React, {
    PureComponent
} from 'react';
import {
    Select, Table, Button, Pagination, MessageBox
} from 'element-react';


import Paging from 'components/Paging'
import {
    Link
} from 'react-router-dom';

export default class TrainingApplication extends PureComponent {

    state = {
        city: [{
            value: '三亚市',
            label: '三亚市'
        }, {
            value: '海口市',
            label: '海口市'
        }, {
            value: '三沙市',
            label: '三沙市'
        }, {
            value: '儋州市',
            label: '儋州市'
        }, {
            value: '五指山市',
            label: '五指山市'
        }, {
            value: '文昌市',
            label: '文昌市'
        }, {
            value: '琼海市',
            label: '琼海市'
        }, {
            value: '万宁市',
            label: '万宁市'
        }, {
            value: '东方市',
            label: '东方市'
        }],

        area: [{
            value: '海棠区',
            label: '海棠区'
        }, {
            value: '吉阳区',
            label: '吉阳区'
        }, {
            value: '天涯区',
            label: '天涯区'
        }, {
            value: '崖州区',
            label: '崖州区'
        }],
        value: '',
        areaValue: ''
    };

    toApplicationProcess = (type) => {
        console.log(type)
        if (type == 1) {
            this.props.history.push('/educationTraining/trainingHandle')
        } else {
            MessageBox.alert('您的档案不存在，无法办理！', '提示');
        }

    }

    toApplicationGuide = (index) => {
        this.props.history.push('/educationTraining/trainingGuide')
    }

    render() {

        const {
            city, area, value, areaValue
        } = this.state;

        const columns = [
            {
                label: "事项名称",
                prop: "name",
                width: 400,
                render: (row, column) => {
                    return <Link to='/educationTraining/deucationTrainingPolicyDetail'> <span style={{ color: '#18388c' }}>{row.name}</span></Link>
                }
            },
            {
                label: "主管部门",
                prop: "department",
            },
            {
                label: "行政区划",
                prop: "administrator",
            },
            {
                label: "操作",
                width: 300,
                render: (data, columns) => {
                    return <span style={{ color: '#1181ea' }}><Button type="text" size="small" onClick={() => this.toApplicationProcess(data.type)}>在线办理</Button><Button style={{ marginLeft: '30px' }} type="text" size="small" onClick={() => this.toApplicationGuide()}>办事指南</Button></span>
                }
            }
        ];

        const dataSource = [
            { 'name': '退役军人医疗补助', 'department': '海棠区退役军人办事处', 'administrator': '三亚市海棠区', 'type': '1' },
            { 'name': '优抚补贴', 'department': '海棠区退役军人办事处', 'administrator': '三亚市海棠区', 'type': '2' },
            { 'name': '退役军人家属随迁安置补助', 'department': '海棠区退役军人办事处', 'administrator': '三亚市海棠区', 'type': '1' },
            { 'name': '退役军人子女教育补助', 'department': '海棠区退役军人办事处', 'administrator': '三亚市海棠区', 'type': '2' },
            { 'name': '退役军人再教育补助', 'department': '海棠区退役军人办事处', 'administrator': '三亚市海棠区', 'type': '1' },
            { 'name': '退役军人高铁、航空优惠补助', 'department': '海棠区退役军人办事处', 'administrator': '三亚市海棠区', 'type': '2' },
            { 'name': '退役军人子女教育补助', 'department': '海棠区退役军人办事处', 'administrator': '三亚市海棠区', 'type': '1' },
            { 'name': '退役军人子女教育补助', 'department': '海棠区退役军人办事处', 'administrator': '三亚市海棠区', 'type': '2' },
            { 'name': '退役军人高铁、航空优惠补助', 'department': '海棠区退役军人办事处', 'administrator': '三亚市海棠区', 'type': '1' },
            { 'name': '退役军人购房、租房补助', 'department': '海棠区退役军人办事处', 'administrator': '三亚市海棠区', 'type': '2' },
        ];
        return (
            <div className="main_application" >
                <div className="main_application_center" >
                    <div className="center_search" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <span>
                            <span style={{ color: '#18388c', fontSize: '24px', marginRight: '15px' }} > 培训申请 </span>

                            <Select value={value} placeholder="请选择" style={{ marginRight: '9px' }}> {
                                city.map(el => {
                                    return <Select.Option key={
                                        el.value
                                    }
                                        label={
                                            el.label
                                        }
                                        value={
                                            el.value
                                        }
                                    />
                                })
                            }
                            </Select><Select value={areaValue}
                                placeholder="请选择" > {
                                    area.map(el => {
                                        return <Select.Option key={
                                            el.value
                                        }
                                            label={
                                                el.label
                                            }
                                            value={
                                                el.value
                                            }
                                        />
                                    })
                                }
                            </Select>
                        </span>


                        <span style={{ fontSize: 14, color: '#333', }}>共有10个事项，其中10项可在线申办</span>
                    </div>


                    <div className="result_table" style={{ marginTop: '10px' }}>
                        <Table
                            style={{ width: '100%' }}
                            columns={columns}
                            data={dataSource}
                            border={false}
                        // onRowClick={this.onRowClick}
                        />
                    </div>

                    <div className="main_application">
                        <Paging total={2} pageSize={10} currentPage={1} />
                    </div>

                </div>
            </div>

        )
    }
}